<template>
  <div id="main_app">
    <navbar></navbar>
    <div class="columns" style="padding-top:10px;padding-right:1px;">
      <div v-if="user.tbl_sys_role.id == 4" class="column is-2">
        <sidebar></sidebar>
      </div>
      <div class="column">
        <router-view name="content"></router-view>
      </div>
    </div>
  </div>

</template>
<script>
//import AppNavMD from './components/AppNavMD'
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Cookies from 'js-cookie';

export default {
  name: "main_app",
  components: {
    Navbar,
    Sidebar
  },
  data() {
    return {
      access: Cookies.get("access"),
      user: Cookies.getJSON("user"),
      form: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    // user() {
    //   return this.$store.getters.getUser;
    // },
    // loggedin() {
    //   return this.$store.getters.getLoggedin;
    // }
  },
  watch: {
    user: function(val) {
      if (this.access > 0) {
        if (this.user.tbl_sys_user.firstlogin) {
          this.$router.push({
            path: "/firstlogin"
          });
        } else {
          if (this.user.tbl_sys_user.locked_system) {
            this.$message.error("System is vergrendeld!");
          } else {
            this.$message.success(val.msg);
            //redirect to editpage

            if (this.user.data.tbl_sys_role.id == 4) {
              this.$router.push({
                path: "okrvoorzitter/"
              });
            } else {
              this.$router.push({
                path: "okr/"
              });
            }
          }
        }
      } else {
        if (this.user.tbl_sys_user.locked_system) {
          this.$message.error("System is vergrendeld!");
        } else {
          this.$message.error(val.msg);
        }
      }
    }
  },
  methods: {
    Recover() {
      this.$router.push({
        path: "/recover"
      });
    },
    onSubmit() {
      console.log(this.form.username);
      console.log(this.form.password);
      console.log(this.form);
      this.$store.dispatch("login", {
        username: this.form.username,
        password: this.form.password
      });
    }
  }
};
</script>
